import cx from 'classnames';
import { WEEKDAYS } from 'constants/dates';

import { useBusiness } from 'hooks/business/useBusiness';

import { getFormattedBusinessHours } from 'utils/getFormattedBusinessHours';

import { InfoBlock } from './InfoBlock';

import s from './ClassicBusinessHoursSection.module.css';

export const ClassicBusinessHoursSection = () => {
  const { businessHours } = useBusiness();

  return (
    <InfoBlock as="section">
      <h2 className={s.title}>Business Hours</h2>
      <dl className={s.hoursWrap}>
        {WEEKDAYS.map((name) => {
          const { start, end, working } = businessHours[name.toLowerCase()];

          if (working) {
            return (
              <div key={name} className={s.dayRow}>
                <dt>{name}</dt>
                <dd>
                  {getFormattedBusinessHours(start)} -{' '}
                  {getFormattedBusinessHours(end)}
                </dd>
              </div>
            );
          }
          return (
            <div key={name} className={cx(s.dayRow, s.dayClosed)}>
              <dt>{name}</dt>
              <dd>Closed</dd>
            </div>
          );
        })}
      </dl>
    </InfoBlock>
  );
};
